import { Auswahl } from "../Auswahl";
import { Farbmenuselect } from "./Farbmenuselect";
import { findAuswahl, getRichProfilkategorien } from "../../arrangement/elementFunctions";
import { PositionInput } from "./ZaunCircleMenuItemProfil";
import { Zusatzartikel } from "./Zusatzartikel";
import {
  getMaxTrafoTyp,
  getTrafoTypen,
  getVerbrauch,
} from "../../arrangement/lichtleistenFunctions";
import { lichtleistenZubehörAnzahlKeyfilter } from "../../arrangement/arrangementFunctions";
import { SvgButton } from "../../commons/SvgButton";
import { TrashBinSvg } from "../../inlinesvgs/TrashBinSvg";
import React from "react";

export function getTrafoTypenVerwendbar() {
  const agt = APP.arrangement;
  const hasLichtSmartControlSet =
    agt.lichtleistenZubehörAnzahl["3834 SYSTEM Licht Smart Control Set"] > 0;
  const trafoTypen = getTrafoTypen();
  const maxVerbrauch = _.max(agt.trafoTrees.map((t) => getVerbrauch(t)));
  return hasLichtSmartControlSet
    ? [getMaxTrafoTyp()]
    : trafoTypen.filter((t) => maxVerbrauch <= t.Leistung);
}

export function TrafoAuswahl() {
  const agt = APP.arrangement;
  const trafoAuswahl = findAuswahl("Trafo");
  const trafoAutomatisch = APP.richMetadata.findAuswahlwert("Licht_Trafo_automatisch");
  const trafoOptionen = [
    ...getTrafoTypenVerwendbar()
      .map(({ Key }) => Key)
      .map((Key) => APP.richMetadata.findAuswahlwert(Key)),
    trafoAutomatisch,
  ];
  const trafoValue = agt.lichttrafoAuswahlwert ?? trafoAutomatisch;
  return (
    <Auswahl
      auswahl={trafoAuswahl}
      auswahlwerte={trafoOptionen}
      value={trafoValue}
      onChange={(v) => {
        agt.lichttrafoAuswahlwert = v;
        APP.dirty();
      }}
    />
  );
}

export function LichtKategorien() {
  const agt = APP.arrangement;
  const { Profilkategorie, Profil, Profilleiste } = agt.auswahlAccessoren;
  const profilKategorieAuswahlwert =
    agt.selectedObjects[0]?.isElement && agt.selectedObjects[0]?.profilKategorieAuswahlwert;
  const profilkategorien = getRichProfilkategorien();
  const lichtKategorien = profilkategorien.filter(
    (k) => k.kategorieAuswahlwert.Typinfo == "Lichtleiste"
  );
  return (
    <>
      {lichtKategorien
        .filter(({ profilAuswahlwerte }) => profilAuswahlwerte.length > 0)
        .map(({ kategorieAuswahlwert, profilAuswahlwerte, profilleisteAuswahlwerte }, i) => (
          <div
            key={i}
            className="DekorOptionen"
            role="group"
            aria-labelledby={`licht-kategorie-${i}`}
          >
            <div id={`licht-kategorie-${i}`} className="headline-kategorie">
              {kategorieAuswahlwert.Name}
            </div>
            <div className="flex column-container" data-group-key="Profilkategorie">
              <Farbmenuselect
                auswahlwerte={profilAuswahlwerte}
                value={
                  profilKategorieAuswahlwert == kategorieAuswahlwert &&
                  (Profil.auswahlwert ?? agt.profilAuswahlwert)
                }
                onChange={(profil) => {
                  Profilkategorie.setter(kategorieAuswahlwert);
                  Profil.setter(profil);
                }}
                className="pfosten-item"
              />
            </div>
            <br />
          </div>
        ))}
    </>
  );
}

function LichtkappenHinweis() {
  const agt = APP.arrangement;
  const selectCorrespondingPfosten = () => {
    const selected = agt.selectedObjects;
    if (selected.length == 0) {
      APP.arrangement.activeTabKey = "Pfosten";
      APP.updateUI();
    } else {
      const allePfosten = [];
      selected.forEach((e) => {
        allePfosten.push(e.getPfosten());
      });
      agt.setSelectedObjects(allePfosten.flat());
    }
    APP.dirty();
  };

  const isLichtkappePossible = agt
    .getElemente()
    .some((el) => el.getPfosten().some((pfosten) => pfosten.availableLichtkappen.length > 0));
  if (!isLichtkappePossible) {
    return null;
  }

  return (
    <>
      <div className="headline-kategorie">{I18N("Pfostenkappen")}</div>
      <div className="flex column-container" data-group-key="Pfostenkappen">
        {I18N("Pfostenkappen Linktext")}
        <button
          onClick={selectCorrespondingPfosten}
          className="primary-button fertig-button large font-size-large"
          data-button-key="save"
          aria-label={I18N("aria::Pfostentab öffnen")}
        >
          {I18N("Button Pfostentab")}
        </button>
      </div>
      <br />
    </>
  );
}

export function LichtOptionen() {
  const agt = APP.arrangement;
  const elemente = agt.getSelectedOrAllElemente();
  const sindElementeSelektiert = agt.selectedObjects.some((e) => e.isElement);
  const elementeMitLichtleiste = elemente.filter((e) => e.hasLichtleisten);
  const erstesElementMitLichtleiste = elementeMitLichtleiste[0];

  return (
    <div key="licht-tabs" className="options-tab">
      <div className="scrollarea">
        <LichtKategorien />
        {erstesElementMitLichtleiste && (
          <div className="flex-row gap-2">
            {I18N("Profil Position")}
            <PositionInput
              key={erstesElementMitLichtleiste.id + ".lichtleiste.y"}
              element={erstesElementMitLichtleiste}
              value={
                erstesElementMitLichtleiste.profilPosition ??
                erstesElementMitLichtleiste.sonderprofilMinMax.maxPosition
              }
              setter={(value) => {
                elementeMitLichtleiste.forEach((e) => {
                  if (
                    sindElementeSelektiert ||
                    !e.profilPositionIndividualisiert ||
                    agt.isAllPartsIndividualisiert(
                      agt.getElemente(),
                      "profilPositionIndividualisiert"
                    )
                  ) {
                    e.profilPosition = value;
                    if (sindElementeSelektiert) {
                      e.profilPositionIndividualisiert = true;
                      e.showIndividualisiert = true;
                    }
                  }
                });
                APP.dirty();
              }}
            />
            <SvgButton
              title={I18N("Lichtleiste entfernen")}
              onClick={() => {
                elemente.forEach((e) => {
                  e.showProfil = null;
                  e.profilKategorieAuswahlwert = null;
                  e.profilAuswahlwert = null;
                  e.profilPosition = null;
                });
                agt.update3d();
                APP.dirty();
                APP.logUserAction({ action: "removeLichtleisteButton" });
              }}
              size="large"
            >
              <TrashBinSvg />
            </SvgButton>
          </div>
        )}
        <br />
        <LichtkappenHinweis />
        <br />
        <div className="headline-kategorie">{I18N("Trafo")}</div>
        <TrafoAuswahl />
        <br />
        <div>{I18N("trafoInfotext")}</div>
        <br />
        <Zusatzartikel
          auswahl={findAuswahl("Lichtleisten_Zubehör")}
          zubehör={agt.lichtleistenZubehörAnzahl}
          headerClassName={"headline-kategorie"}
          isKeyValid={lichtleistenZubehörAnzahlKeyfilter}
        />
        <br />
      </div>
    </div>
  );
}
